<template>
  <Transition name="slide-down">
    <div v-if="visible" class="fixed top-0 left-1/2 -translate-x-1/2 w-full max-w-[430px] z-[100] px-4" style="padding-top: calc(12px + var(--safe-top));">
      <div class="rounded-xl px-4 py-3 flex items-start gap-3 shadow-lg"
           :style="{ background: isLimit ? '#CC4444' : '#D4A017' }">
        <div class="flex-1 min-w-0">
          <p class="text-13 font-semibold text-white leading-snug">{{ title }}</p>
          <p class="text-12 text-white/80 leading-snug mt-0.5">
            {{ subtitle }} · <button @click="showInfo = true" class="underline text-white/90">Как устроен лимит</button>
          </p>
          <!-- Момент максимальной мотивации: лимит кончился и человек упёрся.
               Раньше баннер отвечал только «приходите завтра», а попап с
               подпиской показывается один раз в сутки на пороге 90% и к этому
               моменту уже закрыт. Кнопку показываем лишь тем, кому есть что
               предложить: без активной подписки, не админам и не гостям. -->
          <button
            v-if="isLimit && canSubscribe"
            @click="goToSubscription"
            class="mt-2 px-3 py-1.5 rounded-lg bg-white text-12 font-semibold text-error active:bg-white/85 transition-colors"
          >Оформить подписку</button>
        </div>
        <button @click="hide" class="shrink-0 mt-0.5">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>
    </div>
  </Transition>

  <TokenLimitInfoPopup v-model="showInfo" />
</template>

<script setup>
import { ref, computed, watch, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '../store/auth.js'
import { track } from '../analytics.js'
import { iosSalesDisabled } from '../services/sales.js'
import TokenLimitInfoPopup from './TokenLimitInfoPopup.vue'

const authStore = useAuthStore()
const router = useRouter()
const visible = ref(false)
const showInfo = ref(false)
let hideTimer = null

const isLimit = computed(() => authStore.tokenBudget.pct >= 100)
const isWarning = computed(() => authStore.tokenBudget.pct >= 90 && authStore.tokenBudget.pct < 100)

const title = computed(() => {
  if (isLimit.value) return 'Дневной лимит исчерпан'
  return `Использовано ${authStore.tokenBudget.pct}% дневного лимита`
})

const subtitle = computed(() => 'Обнуление завтра в 5:00')

// Гостю подписку не продать — у него ещё нет аккаунта, а у админа лимита нет.
// В iOS-сборке не продать никому — вариант B, см. services/sales.js.
const canSubscribe = computed(() => {
  if (iosSalesDisabled) return false
  const u = authStore.user
  if (!u || u.is_admin || u.is_guest) return false
  return !(u.is_premium && u.subscription_end && new Date(u.subscription_end) > new Date())
})

function goToSubscription() {
  track('token_limit_subscribe_click', { pct: authStore.tokenBudget?.pct })
  hide()
  router.push('/subscription')
}

watch(() => authStore.showTokenWarning, (val) => {
  if (val) {
    visible.value = true
    clearTimeout(hideTimer)
    if (!isLimit.value) {
      hideTimer = setTimeout(() => { visible.value = false; authStore.showTokenWarning = false }, 7000)
    }
  }
})

function hide() {
  visible.value = false
  authStore.showTokenWarning = false
  clearTimeout(hideTimer)
}

onUnmounted(() => clearTimeout(hideTimer))
</script>

<style scoped>
.slide-down-enter-active,
.slide-down-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.slide-down-enter-from,
.slide-down-leave-to {
  transform: translateX(-50%) translateY(-100%);
  opacity: 0;
}
.slide-down-enter-to,
.slide-down-leave-from {
  transform: translateX(-50%) translateY(0);
  opacity: 1;
}
</style>
